import { memo, useEffect, useState } from "react";
import styled from "styled-components";
import { ProjectAPIs } from "~/common/typescript/apis/ProjectAPIs";
import { Project_Base } from "~/common/typescript/models/Project";
import ProjectItem from "../ProjectItem/ProjectItem";
import { Button } from "antd";
import { LuPlus } from "react-icons/lu";
import { remote_getMyWorkspaces } from "~/common/typescript/apis/WorkspaceAPIs";
import { Workspace_Response } from "~/common/typescript/models/Workspace";

const MyProjectList = () => {
  const [myProjects, setMyProjects] = useState<Project_Base[]>([]);
  const [myOrganizations, setMyOrganizations] = useState<Workspace_Response[]>([]);
  const [organizationFilter, setOrganizationFilter] = useState<string>('all');
  const [filteredProjects, setFilteredProjects] = useState<Project_Base[]>([]);

  useEffect(() => {
    ProjectAPIs.remote_getMyProjects()
      .then((projects) => {
        setMyProjects(Array.isArray(projects) ? projects : []);
      })
      .catch((err) => {
        console.error('Error fetching my projects:', err);
        setMyProjects([]);
      });

    remote_getMyWorkspaces()
      .then((workspaces) => {
        setMyOrganizations(Array.isArray(workspaces) ? workspaces : []);
      })
      .catch((err) => {
        console.error('Error fetching workspaces:', err);
        setMyOrganizations([]);
      });
  }, []);

  useEffect(() => {
    let result = Array.isArray(myProjects) ? [...myProjects] : [];

    if (organizationFilter === 'personal') {
      result = result.filter(project => !project.organization);
    } else if (organizationFilter !== 'all') {
      result = result.filter(project => project.organization?.id?.toString() === organizationFilter);
    }

    setFilteredProjects(result);
  }, [myProjects, organizationFilter]);

  return <UI_Wrapper>
    <UI_Header>
      <UI_TitleRow>
        <UI_Title>Dự án của tôi</UI_Title>
        {filteredProjects.length > 0 && <UI_Badge>{filteredProjects.length}</UI_Badge>}
      </UI_TitleRow>
      <UI_OrganizationSelector
        value={organizationFilter}
        onChange={(e) => setOrganizationFilter(e.target.value)}
      >
        <option value="all">Tất cả tổ chức</option>
        <option value="personal">Cá nhân</option>
        {myOrganizations.map(org => (
          <option key={org.id} value={org.id!.toString()}>
            {org.name}
          </option>
        ))}
      </UI_OrganizationSelector>
    </UI_Header>
    <UI_List>
      {
        filteredProjects.map((project) => {
          return <ProjectItem key={project.id} project={project} />
        })
      }
    </UI_List>
    {
      filteredProjects.length === 0 && <div style={{ padding: 8, color: '#aaa' }}>Không có dự án nào</div>
    }
  </UI_Wrapper>
}
export default memo(MyProjectList);

const UI_Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
  background-color: #fff;
  border-radius: 8px;

  @media (max-width: 768px) {
    padding: 12px;
    gap: 8px;
  }

  @media (max-width: 480px) {
    padding: 8px;
    gap: 6px;
    border-radius: 6px;
  }
`;

const UI_List = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 10px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 8px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 6px;
  }
`
const UI_Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 12px;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

const UI_TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const UI_Title = styled.h2`
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
`;

const UI_Badge = styled.span`
  background: #f1f5f9;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
`;

const UI_OrganizationSelector = styled.select`
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background-color: white;
  font-size: 14px;
  cursor: pointer;
  min-width: 200px;

  &:focus {
    outline: none;
    border-color: #667eea;
  }

  @media (max-width: 480px) {
    width: 100%;
    min-width: unset;
  }
`